import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App  } from 'vue'
import { onMounted, watch, computed, unref, ref, nextTick } from 'vue'
import { Layout, getParentLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { NO_RESET_WHITE_LIST } from '@/constants'

const { t } = useI18n()
const isEn = computed(() => {
  return localStorage.getItem('lang')
    ? JSON.parse(localStorage.getItem('lang')).value === 'en'
    : false
})
export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard/home',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect2',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/registered',
    component: () => import('@/views/Login/Registered.vue'),
    name: 'registered',
    meta: {
      hidden: true,
      title: '注册',
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/forgotPassword',
    component: () => import('@/views/Login/forgotPassword.vue'),
    name: 'forgotPassword',
    meta: {
      hidden: true,
      title: '忘记密码',
      noTagsView: true
    }
  },
  {
    path: '/public/MarketInsights',
    component: () => import('@/views/Public/MarketInsights.vue'),
    name: 'PublicMarketInsights',
    meta: {
      hidden: true,
      title: '市场行情',
      noTagsView: true
    }
  },
  {
    path: '/public/MarketInsightsEn',
    component: () => import('@/views/Public/MarketInsightsEn.vue'),
    name: 'PublicMarketInsightsEn',
    meta: {
      hidden: true,
      title: 'MarketInsights',
      noTagsView: true
    }
  },
  {
    path: '/public/MarketInsights_Mobile',
    component: () => import('@/views/Public/MarketInsights_Mobile.vue'),
    name: 'PublicMarketInsightsMobile',
    meta: {
      hidden: true,
      title: '市场行情',
      noTagsView: true
    }
  },
  {
    path: '/invite/Unregistered',
    component: () => import('@/views/invite/Unregistered.vue'),
    name: 'Unregistered',
    meta: {
      hidden: true,
      title: '未注册',
      noTagsView: true
    }
  },

  {
    path: '/invite/NotSettledIn',
    component: () => import('@/views/invite/NotSettledIn.vue'),
    name: 'NotSettledIn',
    meta: {
      hidden: true,
      title: '未入驻',
      noTagsView: true
    }
  },
  {
    path: '/invite/UnderReview',
    component: () => import('@/views/invite/UnderReview.vue'),
    name: 'UnderReview',
    meta: {
      hidden: true,
      title: '审核中',
      noTagsView: true
    }
  },
  {
    path: '/invite/HaveSettledIn',
    component: () => import('@/views/invite/HaveSettledIn.vue'),
    name: 'HaveSettledIn',
    meta: {
      hidden: true,
      title: '已入驻',
      noTagsView: true
    }
  },
  {
    path: '/invite/Bound',
    component: () => import('@/views/invite/Bound.vue'),
    name: 'Bound',
    meta: {
      hidden: true,
      title: '去报盘',
      noTagsView: true
    }
  },
  {
    path: '/Offer',
    component: Layout,
    redirect: '/Offer/InternationalResp/InternationalOfferForm',
    name: 'InternationalResp',
    meta: {
      title: '申请国际报盘',
      hidden: true,
      canTo: true
    },
    children: [
      {
        path: 'InternationalResp/InternationalOfferForm',
        component: () => import('@/views/Offer/InternationalResp/InternationalOfferForm.vue'),
        name: 'InternationalOfferForm',
        meta: {
          // title: t('router.personalCenter'),
          title: '申请国际报盘',
          hidden: true,
          canTo: true
        }
      }
    ]
  },
  {
    path: '/personal',
    component: Layout,
    redirect: '/personal/personal-center',
    name: 'Personal',
    meta: {
      title: t('router.personal'),
      hidden: true,
      canTo: true
    },
    children: [
      {
        path: 'personal-center',
        component: () => import('@/views/Personal/PersonalCenter/PersonalCenter.vue'),
        name: 'PersonalCenter',
        meta: {
          // title: t('router.personalCenter'),
          title: isEn.value ? 'Personal Center' : '个人中心',
          hidden: true,
          canTo: true
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   redirect: '/dashboard/home',
  //   name: 'Dashboard',
  //   meta: {
  //     title: "首页",
  //     icon: 'vi-ant-design:dashboard-filled',
  //     alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'home',
  //       component: () => import('@/views/Dashboard/Home.vue'),
  //       name: 'Home',
  //       meta: {
  //         title: '首页',
  //         noCache: true,
  //         affix: true
  //       }
  //     },
  //     {
  //       path: 'analysis',
  //       component: () => import('@/views/Dashboard/Analysis.vue'),
  //       name: 'Analysis',
  //       meta: {
  //         title: "分析页",
  //         noCache: true
  //         // affix: true
  //       }
  //     },
  //     {
  //       path: 'workplace',
  //       component: () => import('@/views/Dashboard/Workplace.vue'),
  //       name: 'Workplace',
  //       meta: {
  //         title: "工作台",
  //         noCache: true
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/account',
  //   component: Layout,
  //   redirect: '/account/enterprisesInfo',
  //   name: 'Account',
  //   meta: {
  //     title: '企业',
  //     icon: 'vi-ant-design:dashboard-filled',
  //     alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'enterprisesInfoPar',
  //       name: 'enterprisesInfoPar',
  //       component: getParentLayout(),
  //       redirect: '/account/enterprisesInfo',
  //       meta: {
  //         title: '企业管理',
  //         alwaysShow: true
  //       },
  //       children: [
  //         {
  //           path: 'enterprisesInfo',
  //           name: 'enterprisesInfo',
  //           component: () => import('@/views/Account/EnterprisesInfo.vue'),
  //           meta: {
  //             title: '企业信息'
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   path: '/offerService',
  //   component: Layout,
  //   redirect: '/offerService',
  //   name: 'OfferService',
  //   meta: {
  //     title: 'Offer Service',
  //     icon: 'vi-ant-design:dashboard-filled',
  //     alwaysShow: false
  //   },
  //   children: [
  //     {
  //       path: 'makeAnOffer',
  //       component: () => import('@/views/OfferService/MakeAnOffer.vue'),
  //       name: 'MakeAnOffer',
  //       meta: {
  //         title: 'Make An Offer',
  //         noCache: true
  //       }
  //     },
  //     {
  //       path: 'myOffers',
  //       component: () => import('@/views/OfferService/MyOffers.vue'),
  //       name: 'MyOffers',
  //       meta: {
  //         title: 'My Offers',
  //         noCache: true
  //       }
  //     },
  //     {
  //       path: 'responseStatistics',
  //       component: () => import('@/views/OfferService/ResponseStatistics.vue'),
  //       name: 'ResponseStatistics',
  //       meta: {
  //         title: 'Response Statistics',
  //         noCache: true
  //       }
  //     },
  //     {
  //       path: 'responses',
  //       component: () => import('@/views/OfferService/Responses.vue'),
  //       name: 'Responses',
  //       meta: {
  //         title: 'Responses',
  //         noCache: true
  //       }
  //     },
  //     {
  //       path: 'customApply',
  //       component: () => import('@/views/OfferService/CustomApply.vue'),
  //       name: 'customApply',
  //       meta: {
  //         title: '我要报盘1',
  //         noCache: true
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/authorization',
  //   component: Layout,
  //   redirect: '/authorization/user',
  //   name: 'Authorization',
  //   meta: {
  //     title: 系统管理,
  //     icon: 'vi-eos-icons:role-binding',
  //     alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'department',
  //       component: () => import('@/views/Authorization/Department/Department.vue'),
  //       name: 'Department',
  //       meta: {
  //         title: 部门管理
  //       }
  //     },
  //     {
  //       path: 'user',
  //       component: () => import('@/views/Authorization/User/User.vue'),
  //       name: 'User',
  //       meta: {
  //         title: 账号管理
  //       }
  //     },
  //     {
  //       path: 'menu',
  //       component: () => import('@/views/Authorization/Menu/Menu.vue'),
  //       name: 'Menu',
  //       meta: {
  //         title: 菜单管理
  //       }
  //     },
  //     {
  //       path: 'role',
  //       component: () => import('@/views/Authorization/Role/Role.vue'),
  //       name: 'Role',
  //       meta: {
  //         title: 角色管理
  //       }
  //     },
  // {
  //       path: 'regional',
  //       component: () => import('@/views/Authorization/Regional/Regional.vue'),
  //       name: 'Role',
  //       meta: {
  //         title: 区域管理
  //       }
  //     }
  //   ]
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  // console.log('router', router)
  app.use(router)
}

export default router
